import PropTypes from 'prop-types';

import React, { useMemo } from 'react';
import styles from './form.module.css';
import { Label } from '../input/label';

function FieldSet({ className = '', ...props }) {
  return <fieldset data-slot="field-set" className={`${styles.fieldSet} ${className}`.trim()} {...props} />;
}

FieldSet.propTypes = {
  className: PropTypes.string,
};

function FieldLegend({ className = '', ...props }) {
  return <legend data-slot="field-legend" className={`${styles.fieldLegend} ${className}`.trim()} {...props} />;
}

FieldLegend.propTypes = {
  className: PropTypes.string,
};

function FieldGroup({ className = '', ...props }) {
  return <div data-slot="field-group" className={`${styles.fieldGroup} ${className}`.trim()} {...props} />;
}

FieldGroup.propTypes = {
  className: PropTypes.string,
};

function Field({ className = '', ...props }) {
  return <div role="group" data-slot="field" className={`${styles.field} ${className}`.trim()} {...props} />;
}

Field.propTypes = {
  className: PropTypes.string,
};

function FieldContent({ className = '', ...props }) {
  return <div data-slot="field-content" className={`${styles.fieldContent} ${className}`.trim()} {...props} />;
}

FieldContent.propTypes = {
  className: PropTypes.string,
};

function FieldLabel({ className = '', ...props }) {
  return <Label data-slot="field-label" className={`${styles.fieldLabel} ${className}`.trim()} {...props} />;
}

FieldLabel.propTypes = {
  className: PropTypes.string,
};

function FieldTitle({ className = '', ...props }) {
  return <div data-slot="field-label" className={`${styles.fieldTitle} ${className}`.trim()} {...props} />;
}

FieldTitle.propTypes = {
  className: PropTypes.string,
};

function FieldDescription({ className = '', ...props }) {
  return <p data-slot="field-description" className={`${styles.fieldDescription} ${className}`.trim()} {...props} />;
}

FieldDescription.propTypes = {
  className: PropTypes.string,
};

function FieldSeparator({ children, className = '', ...props }) {
  return (
    <div data-slot="field-separator" className={`${styles.fieldSeparator} ${className}`.trim()} {...props}>
      {children && <span data-slot="field-separator-content">{children}</span>}
    </div>
  );
}

FieldSeparator.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

function FieldError({ className = '', children, errors = [], ...props }) {
  const content = useMemo(() => {
    if (children) return children;
    if (!errors.length) return null;
    const uniqueErrors = [...new Map(errors.map(error => [error?.message, error])).values()];
    if (uniqueErrors.length === 1) return uniqueErrors[0]?.message;
    return (
      <ul style={{ marginLeft: '1em', listStyle: 'disc' }}>
        {uniqueErrors.map((error, idx) => error?.message && <li key={idx}>{error.message}</li>)}
      </ul>
    );
  }, [children, errors]);
  if (!content) return null;
  return (
    <div role="alert" data-slot="field-error" className={`${styles.fieldError} ${className}`.trim()} {...props}>
      {content}
    </div>
  );
}

FieldError.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  errors: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string,
    }),
  ),
};

export { Field, FieldLabel, FieldDescription, FieldError, FieldGroup, FieldLegend, FieldSeparator, FieldSet, FieldContent, FieldTitle };
